export const statisticsConstants = {
    STATISTICS_REQUEST: 'STATISTICS_GETALL_REQUEST',
    STATISTICS_SUCCESS: 'STATISTICS_GETALL_SUCCESS',
    STATISTICS_FAILURE: 'STATISTICS_GETALL_FAILURE',

     
};